import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { map, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { ProductsModel } from '../../../helpers/objects/dto/products/products-model';
import { BackofficeProductsRequestModel } from '../../../helpers/objects/request/backoffice/backoffice-products/backoffice-products-request-model';
import { BackofficeProductsModel } from '../../../helpers/objects/dto/backoffice/backoffice-products/backoffice-products-model';

@Injectable({
  providedIn: 'root'
})
export class BackofficeProductsService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(private http: HttpClient, @Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel, private router: Router) {
    this.appConfig = appConfigTemp;
  }

  getProducts(filter: BackofficeProductsRequestModel): Observable<any> {
    const httpParams: HttpParams = new HttpParams({
      fromObject: filter as any
    });
    return this.http.get<any>(this.appConfig.api + 'backoffice/products/' + this.appConfig.apiPartnershipId, { params: httpParams }).pipe(
      map((response) => {
        return {
          backofficeProducts: response.body.products,
          pagination: response.body.pagination
        };
      })
    );
  }

  getDetail(productId: string): Observable<BackofficeProductsModel> {
    return this.http.get<any>(this.appConfig.api + 'backoffice/products/' + this.appConfig.apiPartnershipId + '/' + encodeURIComponent(productId)).pipe(
      map((response) => {
        return response.body as BackofficeProductsModel;
      })
    );
  }
  editProduct(data: ProductsModel): Observable<any> {
    return this.http.put<any>(this.appConfig.api + 'backoffice/products/' + this.appConfig.apiPartnershipId, data).pipe(map((response) => response.body));
  }

  getDocuments(productTag: any): Observable<any> {
    const params = new HttpParams({
      fromObject: {
        productTag: productTag
      }
    });
    return this.http.get<any>(this.appConfig.api + 'backoffice/documents/' + this.appConfig.apiPartnershipId, { params }).pipe(
      map((response) => {
        return response.body.medias;
      })
    );
  }

  addDocument(document: any): Observable<any> {
    return this.http.post<any>(this.appConfig.api + 'backoffice/documents/' + this.appConfig.apiPartnershipId, document).pipe(map((response) => response.body));
  }

  editDocument(document: any): Observable<any> {
    return this.http.put<any>(this.appConfig.api + 'backoffice/documents/' + this.appConfig.apiPartnershipId, document).pipe(map((response) => response.body));
  }

  baseURL(): string {
    return this.appConfig.api + 'setup/products-info/' + encodeURIComponent(this.appConfig.apiPartnershipId) + '/documents/content';
  }
  suffixURL(): string {
    const params = new HttpParams({
      fromObject: {
        Authorization: sessionStorage.getItem('token')!
      }
    });
    return params.toString();
  }
  NavigateDocument(row: any) {
    const url = this.baseURL() + '?X-DocumentId=' + row.digitalArchiveId + '&' + this.suffixURL();
    window.open(url, '_blank');
  }

  createProduct(product: ProductsModel) {
    return this.http.post(this.appConfig.api + 'backoffice/products/' + this.appConfig.apiPartnershipId, product);
  }
}
